import {FunctionComponent} from "react";
import RemoveConfirmationDialog from "./remove-confirmation";
import ConfirmationDialog from "./confirmation";
import EditBizFormDialog from "./edit-biz-form-dialog";
import ViewInstallationGuideDialog from "./view-installation-guide";


const ApplicationDialogs: FunctionComponent = () => {


    return (
        <>
            <RemoveConfirmationDialog/>
            <ConfirmationDialog/>
            <EditBizFormDialog/>
            <ViewInstallationGuideDialog/>
        </>
    );
}


export default ApplicationDialogs;
